import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ColorConfigService {
  private colors: string[] = [
    '#000467',
    '#a5abd6',
    '#5258a5',
  
  ];

  constructor() {}

  getColors(): string[] {
    return this.colors;
  }
}
